import { isEmptyObject } from "../../lib/utils";

interface ErrorsObjectKeys {
  [key: string]: string;
}

type FiltersType = {
  id: string;
  value: string 
};

type SortsType = {
  id: string;
  value: string 
};

export type fetchDeliveryNumberPayload = {
  date: string;
};

export type fetchShippingsPayload = {
  filters: FiltersType[] | [];
  sort: SortsType[] | [];
  pagination: {
    limit: number;
    activePage: number;
  }
};

export type CreateShippingPayload = {
  item_name: string;
  quantity: number | undefined;
  weight_kg: number | undefined;
  packing: string;
  item_unit: string;
  total_price: number | '';
  discount_price: number | '';
  payment_status: string;
  notes: string;
  shipping_date: string;
  origin_office_id: string | undefined;
  destination_office_id: string | undefined;
  origin_customer_data : {
    sender_name: string;
    sender_phone: string;
    sender_address: string;
  },
  destination_customer_data : {
    recipient_name: string;
    recipient_phone: string;
    recipient_address: string;
  },
  admin_maker: string | undefined;
};

export type fetchCreateDeliveryReportPayload = {
  // delivery_number: string;
  vehicle_plate_number: string;
  origin_city: string;
  destination_city: string;
  driver_name: string;
  departure_date: string;
  // departure_time: string;
  estimation_arrival_date: string;
  arrival_date: string;
  shipping_ids: string[];
  admin_maker: string | undefined;
};

export type fetchDailyDeliveryData = {
  delivery_number: string;
  vehicle_plate_number: string;
  origin_city: string;
  destination_city: string;
  driver_name: string;
  departure_date: string;
  estimation_arrival_date: string;
  arrival_date: string;
  admin_maker: string | undefined;
};

export type DeliveryStatus = {
  step: number;
  status_code: string;
  status_label: string;
  description: string;
  isDone: boolean;
  _id: string;
};

export type FetchDelivertResponse = {
  _id: string;
  delivery_number: string;
  departure_date: string;
  vehicle_plate_number: string;
  driver_name: string;
  origin_city: string;
  destination_city: string;
  departure_time: string | null;
  estimation_arrival_date: string;
  arrival_date: string | null;
  expenses: [];
  delivery_status: DeliveryStatus[];
  admin_maker: string;
};

export interface CreateDailyDeliveryReportErrors extends ErrorsObjectKeys {
  // deliveryNumber: string;
  platNumber: string;
  driverName: string;
  selectedOriginCity: string;
  selectedDestinationCity: string;
  selectedShippingDate: string;
  selectedArrivalDate: string;
};
export interface SearchDeliveryReportErrors extends ErrorsObjectKeys {
  deliveryNumber: string;
};

export interface CreateShippingErrors extends ErrorsObjectKeys {
  senderName: string;
  senderAddress: string;
  senderPhone: string;
  recipientName: string;
  recipientAddress: string;
  recipientPhone: string;
  originOffice: string;
  destinationOffice: string;
  selectedShippingDate: string;
  quantity: string;
  itemName: string;
  itemUnit: string;
  weightKg: string;
  packing: string;
  discountPrice: string;
  subTotalPrice: string;
  paymentStatus: string;
};

export const validateCreateShippingFormPayload = (payload: CreateShippingPayload) => {
  const { 
    item_name,
    quantity,
    weight_kg,
    packing,
    item_unit,
    total_price,
    payment_status,
    shipping_date,
    origin_office_id,
    destination_office_id,
    origin_customer_data,
    destination_customer_data,
  } = payload;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errors: any = {};

  if(!shipping_date) {
    errors["selectedShippingDate"] = "Wajib diisi";
  };

  if(!origin_office_id) {
    errors["originOffice"] = "Wajib diisi";
  };

  if(!destination_office_id) {
    errors["destinationOffice"] = "Wajib diisi";
  };

  if(!origin_customer_data.sender_name) {
    errors["senderName"] = "Wajib diisi";
  };

  if(!origin_customer_data.sender_phone) {
    errors["senderPhone"] = "Wajib diisi";
  };

  if(!origin_customer_data.sender_address) {
    errors["senderAddress"] = "Wajib diisi";
  };

  if(!destination_customer_data.recipient_name) {
    errors["recipientName"] = "Wajib diisi";
  };

  if(!destination_customer_data.recipient_phone) {
    errors["recipientPhone"] = "Wajib diisi";
  };

  if(!destination_customer_data.recipient_address) {
    errors["recipientAddress"] = "Wajib diisi";
  };

  if(!item_name) {
    errors["itemName"] = "Wajib diisi";
  };

  if(!quantity) {
    errors["quantity"] = "Wajib diisi";
  } else {
    if(quantity < 1) errors["quantity"] = "Tidak boleh 0";
  };

  if(!weight_kg) {
    errors["weightKg"] = "Wajib diisi";
  } else {
    if(weight_kg < 1) errors["weightKg"] = "Tidak boleh 0";
  };

  if(!packing) {
    errors["packing"] = "Wajib diisi";
  };
  
  if(!item_unit) {
    errors["itemUnit"] = "Wajib diisi";
  };
  
  if(!total_price) {
    errors["subTotalPrice"] = "Wajib diisi";
  };

  if(!payment_status) {
    errors["paymentStatus"] = "Wajib diisi";
  };
  
  return {
    isValid: isEmptyObject(errors),
    formErrors: errors
  };
};

export const createShippingData = async(payload: CreateShippingPayload) => {
  const apiURL = process.env.REACT_APP_API_URL+"/shipping/create";

  try {
    const response = await fetch(apiURL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const fetchShippings = async(payload: fetchShippingsPayload) => {
  const apiURL = process.env.REACT_APP_API_URL+"/shipping/list";

  try {
    const response = await fetch(apiURL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const fetchOfficeOptions = async() => {
  const apiURL = process.env.REACT_APP_API_URL+"/office/options";

  try {
    const response = await fetch(apiURL, {method: "GET"});
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const fetchShippingDetails = async(shippingNumber: string) => {
  const apiURL = `${process.env.REACT_APP_API_URL}/shipping/detail/${shippingNumber}`;

  try {
    const response = await fetch(apiURL, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      }
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const fetchTodayDeliveryData = async() => {
  const apiURL = `${process.env.REACT_APP_API_URL}/shipping/today-delivery`;

  try {
    const response = await fetch(apiURL, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      }
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  }
}

export const fetchCreateDeliveryReport = async(payload: fetchCreateDeliveryReportPayload) => {
  const apiURL = `${process.env.REACT_APP_API_URL}/shipping/create-delivery`;

  try {
    const response = await fetch(apiURL, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });
  
    if(!response.ok) {
      console.log(`HTTP Error! Status : ${response.status}`);
      return;
    };
  
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return;
  };
};